export const PAYMENT_PROFILE_COUNTRIES = Object.freeze([
  { isoCode: "US", name: "United States" },
  { isoCode: "GB", name: "United Kingdom" },
  { isoCode: "ES", name: "Spain" },
  { isoCode: "FR", name: "France" },
  { isoCode: "DE", name: "Germany" },
  { isoCode: "IT", name: "Italy" },
  { isoCode: "MX", name: "Mexico" },
  { isoCode: "BR", name: "Brazil" },
  { isoCode: "AR", name: "Argentina" },
  { isoCode: "CO", name: "Colombia" },
  { isoCode: "CL", name: "Chile" },
  { isoCode: "PT", name: "Portugal" },
  { isoCode: "NL", name: "Netherlands" },
  { isoCode: "IE", name: "Ireland" },
  { isoCode: "CA", name: "Canada" },
  { isoCode: "BE", name: "Belgium" },
  { isoCode: "LU", name: "Luxembourg" },
  { isoCode: "CH", name: "Switzerland" },
  { isoCode: "SE", name: "Sweden" },
  { isoCode: "NO", name: "Norway" },
  { isoCode: "DK", name: "Denmark" },
  { isoCode: "FI", name: "Finland" },
  { isoCode: "AU", name: "Australia" },
  { isoCode: "NZ", name: "New Zealand" },
  { isoCode: "JP", name: "Japan" },
  { isoCode: "SG", name: "Singapore" },
  { isoCode: "AE", name: "United Arab Emirates" },
  { isoCode: "SA", name: "Saudi Arabia" },
  { isoCode: "TR", name: "Turkey" },
  { isoCode: "IL", name: "Israel" },
  { isoCode: "KR", name: "South Korea" },
  { isoCode: "CN", name: "China" },
  { isoCode: "IN", name: "India" },
  { isoCode: "HK", name: "Hong Kong SAR" },
  { isoCode: "TW", name: "Taiwan" },
]);

function normalizeCountryValue(value) {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

/**
 * Resolves a stored country value (ISO code or display name) to the ISO code
 * required by Stripe and the payment-country selector.
 */
export function resolvePaymentCountryCode(value) {
  const normalizedValue = normalizeCountryValue(value);
  if (!normalizedValue) return null;

  const normalizedUpperCase = normalizedValue.toUpperCase();
  const normalizedLowerCase = normalizedValue.toLocaleLowerCase();
  const country = PAYMENT_PROFILE_COUNTRIES.find(({ isoCode, name }) => (
    isoCode === normalizedUpperCase || name.toLocaleLowerCase() === normalizedLowerCase
  ));

  return country?.isoCode ?? null;
}

export function resolvePaymentCountryHint({ profile = null, billingAddress = null } = {}) {
  const address = billingAddress ?? profile?.billing_address ?? null;
  const addressCountry = address?.address_country ?? address?.country ?? null;
  const profileCountry = profile?.country ?? profile?.country_code ?? profile?.country_iso ?? profile?.country_iso2 ?? null;

  return resolvePaymentCountryCode(addressCountry) ?? resolvePaymentCountryCode(profileCountry);
}
